<template>
    <b-card no-body>
        <b-card-header>
            <i class="icon-note"></i>
            <strong>{{
                $t('form.create', {
                    item: $t('careerObjective.careerObjective'),
                })
            }}</strong>
        </b-card-header>
        <b-card-body>
            <Form
                :careerObjective="data"
                :isSubmitting="isSubmitting"
                @save="onSubmit"
            />
        </b-card-body>
    </b-card>
</template>

<script>
import Form from './Form'
import { createCareerObjective } from '../../api'
import { mapperFormToApi } from '../../mappers'
import {
    operationSuccessfullySnotification,
    notificationError,
} from '../../functions'

const initialValues = {
    id: Math.random(),
    intended_position: null,
    description: null,
    mobilityDescription: null,
    hasMobility: false,
    type: 'career',
    period: 'one_year',
    departments: [],
}

export default {
    name: 'New',
    components: {
        Form,
    },
    data() {
        return {
            isSubmitting: false,
            data: Object.assign({}, initialValues),
        }
    },
    methods: {
        onSubmit(form) {
            this.isSubmitting = true
            const data = mapperFormToApi(form)
            createCareerObjective(data)
                .then(() => {
                    operationSuccessfullySnotification('create')
                })
                .catch(e => {
                    console.error(e)
                    notificationError()
                })
                .finally(() => {
                    this.isSubmitting = false
                    this.$router.push('/v2/home')
                })
        },
    },
}
</script>

<style></style>
